import { gql } from "apollo-angular";

export const GETALL_SOP_QUERY = gql`query configuratorSop{
    configuratorSop
  }
  `
